import axios from "axios";

//sets the token as a permanent header for axios calls
const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["x-auth-token"] = token;
    axios.defaults.headers.common["timezone-offset"] = `${new Date().getTimezoneOffset()}`
  } else {
    delete axios.defaults.headers.common["x-auth-token"];
  }
};

export default setAuthToken;
